import React, { useState } from "react";
import TableView from "./table/table-view";
import Button from "../../../components/buttons/button";
import CreateEventsModal from "./table/components/create-events-modal";
import { useGetEventsQuery } from "../../../store/Reducer/events";
import TableFilters from "./table/table-filters";
import { Header } from "../../../components/page-header/Header";
import { useTranslation } from "react-i18next";
import TablePaginationCustom from "./table/table-pagination-custom";
import Loader from "../../../components/loaders/loader";

const UserEvents = () => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setsearch] = useState("");

  const {
    data: eventsData,
    isLoading,
    error,
  } = useGetEventsQuery({ page: currentPage, search });

  const openModal = (edit = false, rowData = null) => {
    setIsEdit(edit);
    setSelectedRowData(rowData);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsEdit(false);
    setSelectedRowData(null);
    setIsOpen(false);
  };

  const breadcrumbItems = [
    { label: t("universal_dashboard_text"), to: '/user-dashboard' },
    { label: t("events_breadcurmbs_title") },
  ];

  return (
    <>
      <section className="min-h-[86vh] bg-gradient-to-b from-slate-50 to-gray-50">
        <div className="max-w-7xl mx-auto p-6">
          <div className="">
            <div className="mb-5 header flex justify-between items-center flex-wrap">
              <div className="flex items-center justify-between">
                <Header title={t("events_title")} breadcrumbItems={breadcrumbItems} />
              </div>

              <Button
                text={t("universal_create_text")}
                type="button"
                className="px-6 text-nowrap"
                onClick={() => openModal(false)}
              />
            </div>

            <TableFilters search={search} setSearch={setsearch} />

            {isLoading ? (
              <div className="pt-16 flex justify-center mt-12 items-center">
                <Loader />
              </div>
            ) : (
              <>
                <TableView
                  eventsData={eventsData?.data}
                  onEditRow={(rowData) => openModal(true, rowData)}
                  searching={Boolean(search)}
                />

                <TablePaginationCustom
                  details={eventsData?.pagination || []}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalPages={eventsData?.pagination?.totalPages || 1}
                  totalItems={eventsData?.pagination?.totalEvents}
                />
              </>
            )}
          </div>
        </div>
      </section>

      <CreateEventsModal
        isOpen={isOpen}
        closeModal={closeModal}
        isEdit={isEdit}
        rowData={selectedRowData}
      />
    </>
  );
};

export default UserEvents;
